import React, { useState } from "react";

import { TextField, Button } from "@material-ui/core";

import TestAuthService from "../services/testAuth";
import user from "../services/user";

export default (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [token, setToken] = useState("");
  const [refreshToken, setRefreshToken] = useState("");
  const [exp, setExp] = useState("");
  const [error, setError] = useState("");
  const [expTimestamp, setExpTimestamp] = useState("");

  const submit = () => {
    TestAuthService()
      .authUser(username, password)
      .then((resp) => {
        if (resp.token) {
          setToken(resp.token);
          setRefreshToken(resp.refreshToken);
          setExpTimestamp(resp.expTimestamp);
        } else {
          setError(error);
        }
      });
  };

  const submitReAuth = () => {
    TestAuthService()
      .refreshUserAuth(refreshToken)
      .then((resp) => {
        if (resp.token) {
          setToken(resp.token);
          setExpTimestamp(resp.expTimestamp);
        } else {
          setError(error);
        }
      });
  };

  return (
    <div>
      <h1>Hello Reauth World</h1>
      <div style={{ margin: 50 }}>
        <div>
          <TextField
            label="username"
            onChange={(e) => {
              setUsername(e.target.value);
            }}
            value={username}
          />
        </div>
        <div>
          <TextField
            label="password"
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            value={password}
          />
        </div>
        <div style={{ margin: 10 }}>
          <Button
            variant="outlined"
            onClick={() => {
              submit();
            }}
          >
            Auth User
          </Button>
          <Button
            style={{ marginLeft: 50 }}
            variant="outlined"
            onClick={() => {
              submitReAuth();
            }}
          >
            Update Expiration -- ReAuthUser
          </Button>
        </div>
        <div>
          <h1>RESPONSE:</h1>
          <div>Token:{token}</div>
          <div>ReAuthToken:{refreshToken}</div>
          <div>ExpTimestamp:{expTimestamp}</div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/layout/Reauth.js